export default "__VITE_ASSET__B88L85G5__"